import { render, staticRenderFns } from "./badgeLayout.vue?vue&type=template&id=87498496&scoped=true&"
import script from "./badgeLayout.vue?vue&type=script&lang=js&"
export * from "./badgeLayout.vue?vue&type=script&lang=js&"
import style0 from "./badgeLayout.vue?vue&type=style&index=0&id=87498496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87498496",
  null
  
)

export default component.exports